import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { globalIssueNavigatorEntryPoint } from '@atlassian/jira-spa-apps-global-issue-navigator/entrypoint.tsx';
import { nativeIssueTableEntryPoint } from '@atlassian/jira-native-issue-table/src/ui/entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { jqlBuilderWithAiEntryPoint } from '@atlassian/jira-jql-builder-with-ai/src/ui/entrypoint.tsx';

export const globalIssueNavigatorGinRedirectEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-global-issue-navigator-gin-redirect-entrypoint" */ './index.tsx'
			),
		{ entryFsSsrLiftImportToModule: true },
	),
	getPreloadProps: (entryPointParams: EntryPointRouteParams) => {
		const issueKey = entryPointParams?.context?.match?.params?.issueKey;

		return {
			entryPoints: {
				globalIssueNavigatorEntryPoint: {
					entryPoint: globalIssueNavigatorEntryPoint,
					entryPointParams,
				},
				...(!issueKey
					? {
							nativeIssueTableEntryPoint: {
								entryPoint: nativeIssueTableEntryPoint,
								entryPointParams,
							},
							...(fg('jql_builder_basic_ssr_stability_fixes')
								? {
										jqlBuilderWithAiEntryPoint: {
											entryPoint: jqlBuilderWithAiEntryPoint,
											entryPointParams,
										},
									}
								: {}),
						}
					: {}),
			},
		};
	},
});
